import { RcFile } from 'antd/es/upload';
import { isNullOrWhiteSpaces } from 'src/shared/utils/strings';

interface ContractingInfoFile {
  id?: string;
  fileName: string;
  mimeType: string;
  file?: RcFile;
}

interface FileInfo {
  id?: string;
  fileName: string;
  mimeType: string;
  size: number;
}

export const splitFileInfo = (
  f?: ContractingInfoFile
): {
  file?: RcFile;
  fileInfo?: FileInfo;
} => {
  if (f == null) return { file: undefined, fileInfo: undefined };
  const { file, id, fileName, mimeType } = f;
  return {
    file,
    fileInfo:
      !isNullOrWhiteSpaces(id) || !isNullOrWhiteSpaces(fileName) || !isNullOrWhiteSpaces(mimeType)
        ? { id, fileName, mimeType, size: file?.size }
        : (undefined as any)
  };
};
